import $ from "jquery/dist/jquery";
const jQuery = $;

// Generated by CoffeeScript 2.7.0
(function () {
  (function ($) {
    return $(function () {
      return $("#newsletter-form").submit(function (e) {
        var f;
        e.preventDefault();
        f = $(this);
        $("#newsletter-form").fadeOut("fast");
        return $.ajax({
          url: f.attr("action"),
          method: "POST",
          data: f.serialize(),
        }).success(function () {
          $("#newsletter-form").fadeOut("fast");
          setTimeout(function () {
            return $("#newsletter-form").fadeIn("fast");
          }, 15000);
          setTimeout(function () {
            return $("#success-message").fadeIn("fast");
          }, 500);
          return setTimeout(function () {
            return $("#success-message").fadeOut("fast");
          }, 14000);
        });
      });
    });
  })(jQuery);
}).call(this);
